import React, { useState, useEffect } from "react";
import { SwatchesPicker   } from 'react-color'
import { SketchPicker   } from 'react-color'
import { CompactPicker   } from 'react-color'
import { Col, Form, Row, Button, ButtonGroup} from "react-bootstrap";
import { useTranslation } from 'react-i18next';



export const ColorPicker = (props) => {
  const { t } = useTranslation();
  const [cor, setCor] = useState('#ffffff');

  const [exibeColor, setExibeColor] = useState(false)

  const handleColor = async (event) => {
    setExibeColor(true);
  };

  useEffect(() => {    
    setCor(props.color);
  }, [props.color]);

  return (
    <>
    {exibeColor &&
      <CompactPicker
        color={cor || '#ffffff'}
        onChangeComplete={(val) => {
          setCor(val.hex)
          props.handleChangeColor(val, props.index, props.data);
          setExibeColor(false);
        }}
      />
    }  

    {exibeColor == false &&
      <ButtonGroup>
        <Button 
        onClick={handleColor} 
        type="button" 
        style={{minWidth: 100}}>
          <span>{t("SELECT_COLOR")}</span>
        </Button>
        <div style={{minWidth: 30, backgroundColor: cor, marginLeft:10}}>
        </div> 
      </ButtonGroup>
    }

    </>
  );
};


// {exibeColor &&
//   <ColorPicker
//   color = {values.equipmentConfig[index].color}
//   handleChangeColor={handleChangeColor}
//   data={values}
//   index={values.equipmentConfig[index].id}
//   visibled={false}
//   />
// }    
// {exibeColor == false &&
//  <ButtonGroup>
//     <Button onClick={handleColor} type="button" style={{minWidth: 100 }}>
//     <span>{t("SELECT_COLOR")}</span>
//     </Button>
//  </ButtonGroup>
// }            
